module.exports = __webpack_public_path__ + "media/images/common/completed-1521cbd76518516b794e25bfc9b5b694.png";